import { jsx as _jsx } from "react/jsx-runtime";
import MenuItem from './MenuItem';
var MenuList = function (_a) {
    var items = _a.items, ItemComponent = _a.ItemComponent, onClose = _a.onClose;
    return (_jsx("ul", { children: items &&
            items.map(function (item, i) {
                return !item.hidden && _jsx(MenuItem, { item: item, ItemComponent: ItemComponent, onClose: onClose }, i);
            }) }));
};
export default MenuList;
